export const CustomAudienceType = {
  CUSTOM: 'CUSTOM',
  LOOKALIKE: 'LOOKALIKE',
}

export const CustomAudienceTypeSortOrder = {
  [CustomAudienceType.CUSTOM]: 2,
  [CustomAudienceType.LOOKALIKE]: 1,
}

export const CustomAudienceActionType = {
  add: 'add',
  remove: 'remove',
}
